import { getConfig } from '@/constants/config';

const MailToCustomerService = () => {
  const customerServiceEmail = getConfig().customerServiceEmail;

  return (
    <a className="link" href={`mailto:${customerServiceEmail}`}>
      {customerServiceEmail}
    </a>
  );
};

export default MailToCustomerService;
